<template>
  <div>
    <div class="flex flex-col divide-y-1.5">
      <div class="p-7 flex flex-col gap-2 text-sm">
        <p>My Evaluation</p>
        <p>My Evaluation Percentage 100%</p>
        <div>
          <label>My Comments</label>
          <textarea
            class="p-1 bg-gray-100 rounded-xl w-full mt-2"
            cols="5"
          ></textarea>
        </div>
      </div>
      <div class="p-7 flex flex-col gap-2 text-sm">
        <p>Lilian Doe Evaluation</p>
        <p>Evaluation Percentage 100%</p>
        <div>
          <label>Comments</label>
          <textarea
            class="p-1 bg-gray-100 rounded-xl w-full mt-2"
            cols="5"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="flex justify-end p-5">
      <button class="bg-primary rounded-full px-10 text-sm text-white py-2">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Evaluation",
};
</script>